import { Home, LogOut, ShieldCheck, Store, UserRound } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDesignerStore } from '../state/session';
import { api } from '../services/api';

export function Header() {
  // در صفحه ادمین، دکمه «پنل مدیریت» به «صفحه اصلی» تبدیل می‌شود
  // تا مدیر با یک کلیک به سایت بازگردد.
  const pathname = useLocation().pathname;
  const onAdmin = pathname.startsWith('/admin');
  const onAccount = pathname.startsWith('/account');
  const onDesign = pathname.startsWith('/design');
  const accountUser = useDesignerStore((state) => state.accountUser ?? state.state?.user ?? null);
  const clearUserToken = useDesignerStore((state) => state.clearUserToken);
  const navigate = useNavigate();

  const logout = async () => {
    try { await api.logoutAccount(); } catch { /* Local sign-out must still work offline. */ }
    clearUserToken();
    navigate('/account', { replace: true });
  };

  return (
    <header className={`site-header${onAdmin ? ' admin-mode' : ''}`}>
      <Link to="/" className="brand" aria-label="صفحه اصلی کارولایت">
        <span className="brand-mark" aria-hidden="true">
          <img src="/karolight-logo.webp" alt="" className="brand-logo" />
        </span>


        <span>
          <strong>کارو لایت</strong>
          <small>طراح هوشمند نور</small>
        </span>
      </Link>

      <nav className="header-actions" aria-label="دسترسی سریع">
        <a
          className="quiet-button store-link"
          href="https://karolightcompany.com"
          target="_blank"
          rel="noreferrer"
          aria-label="بازگشت به فروشگاه"
          title="بازگشت به فروشگاه"
        >
          <Store size={17} />
          <span>بازگشت به فروشگاه</span>
        </a>

        {!onAdmin && (onAccount && accountUser ? (
          <span className="quiet-button account-header-identity" aria-label={`حساب کاربری ${accountUser.name}`} title={accountUser.name}>
            <UserRound size={17} />
            <span>{accountUser.name}</span>
          </span>
        ) : (
          <Link className="quiet-button account-nav-link" to="/account" aria-label={accountUser ? `حساب کاربری ${accountUser.name}` : 'حساب کاربری'} title={accountUser ? `حساب کاربری ${accountUser.name}` : 'حساب کاربری'}>
            <UserRound size={17} />
            <span>{accountUser?.name || 'حساب کاربری'}</span>
          </Link>
        ))}

        {onAccount && accountUser && <button className="quiet-button header-logout" type="button" onClick={() => void logout()} aria-label="خروج از حساب کاربری" title="خروج از حساب کاربری"><LogOut size={17} /><span>خروج</span></button>}

        {onAdmin ? (
          <Link className="quiet-button" to="/" aria-label="صفحه اصلی" title="صفحه اصلی">
            <Home size={17} />
            <span>صفحه اصلی</span>
          </Link>
        ) : onAccount ? (
          <Link
            className="quiet-button account-home-link"
            to="/"
            aria-label="صفحه اصلی"
            title="صفحه اصلی"
          >
            <Home size={17} />
            <span>صفحه اصلی</span>
          </Link>
        ) : !onDesign ? (
          <Link className="quiet-button" to="/admin" aria-label="پنل مدیریت" title="پنل مدیریت">
            <ShieldCheck size={17} />
            <span>پنل مدیریت</span>
          </Link>
        ) : null}
      </nav>
    </header>
  );
}
